

import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as PlusSquareFill } from "bootstrap-icons/icons/plus-square-fill.svg";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
import { ReactComponent as Cash } from "bootstrap-icons/icons/cash.svg";
import { ReactComponent as CardList } from "bootstrap-icons/icons/card-list.svg";
import { ReactComponent as CardHeading } from "bootstrap-icons/icons/card-heading.svg";
import { ReactComponent as PeopleFill } from "bootstrap-icons/icons/people-fill.svg";
import { ReactComponent as PersonLinesFill } from "bootstrap-icons/icons/person-lines-fill.svg";
import { ReactComponent as ShieldFillPlus } from "bootstrap-icons/icons/shield-fill-plus.svg";
import { ReactComponent as Wallet2 } from "bootstrap-icons/icons/wallet2.svg";
import { ReactComponent as CashCoin } from "bootstrap-icons/icons/cash-coin.svg";
import { ReactComponent as PersonVcardFill } from "bootstrap-icons/icons/person-vcard-fill.svg";
import { ReactComponent as CardCheckList } from "bootstrap-icons/icons/card-checklist.svg";
import { ReactComponent as ChevronDown } from "bootstrap-icons/icons/chevron-down.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import { ReactComponent as LockFill } from "bootstrap-icons/icons/lock-fill.svg";
import { ReactComponent as Building } from "bootstrap-icons/icons/building.svg";
import formatDate from "../../../components/utils/DateFormatter";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import { downloadCSVFromApi } from "../../../components/utils/DownlaodCSVFromApi";

const BranchList = () => {
  const [branchOpe, setBranchOpe] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedBranchStatus, setSelectedBranchStatus] = useState("");
  const [selectedActivationStatus, setSelectedActivationStatus] = useState("");
  const { permissions } = useContext(AuthContext);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const navigate = useNavigate();

  //axios api encryption call
  const axios = AxiosApiCall();

  const fetchAllbranchList = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.get(ApiServices.getAllBranchOperations, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data;

      if (status === 200) {
        const sortedData = data
          .slice()
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setBranchOpe(sortedData);
        toast.success(message, { toastId: "product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllbranchList();
  }, []);

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;

  // Handle status selection
  const handleStatusSelect = (status) => {
    setSelectedBranchStatus(status);
    setIsDropdownOpen(false);
  };

  // Handle activation status selection
  const handleActivationStatusSelect = (status) => {
    setSelectedActivationStatus(status);
    setIsDropdownOpen(false);
  };

  // Handle CSV Download
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload
      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        download: 1,
      };

      // Create filename with date range
      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `branches_${startDateFormatted}_to_${endDateFormatted}.csv`;

      // Call the download function
      await downloadCSVFromApi(
        ApiServices.getAllBranchOperations,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000,
          navigate: navigate,
        }
      );

    } catch (error) {
      // console.error("Download error:", error);
      handleError(error, navigate);
      // Additional download-specific error messages
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Handle Activate Confirmation
  const handleActivateConfirmation = (branchId, isActivated) => {
    const actionText = isActivated ? "Deactivate" : "Activate";
    const confirmButtonColor = isActivated ? "#d33" : "#3085d6";

    setConfirmationLoading(true);

    Swal.fire({
      title: `Are you sure you want to ${actionText} this branch?`,
      text: `This will ${isActivated ? "deactivate" : "activate"} the branch.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: "#aaa",
      confirmButtonText: `Yes, ${actionText} it!`,
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleActivateBranch(branchId);
      }
    });
  };

  // Handle branch activation
  const handleActivateBranch = async (branchId) => {
    const formData = {
      branch_id: branchId,
    };
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.patch(ApiServices.activateBranchOpe, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message);
        await fetchAllbranchList();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  // reset password
  const handleResetPasswordConfirmation = (branchId) => {
    const actionText = "Reset Password";
    const confirmButtonColor = "#3085d6";

    setConfirmationLoading(true);

    Swal.fire({
      title: `Are you sure you want to ${actionText} this branch?`,
      text: `This will reset the password for the branch.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: confirmButtonColor,
      cancelButtonColor: "#aaa",
      confirmButtonText: `Yes, ${actionText} it!`,
    }).then((result) => {
      setConfirmationLoading(false);
      if (result.isConfirmed) {
        handleActivateResetPassword(branchId);
      }
    });
  };

  // Handle branch activation
  const handleActivateResetPassword = async (branchId) => {
    const formData = {
      branch_id: branchId,
    };
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.post(ApiServices.resetBranchOpePassword, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message);
        await fetchAllbranchList();
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => {
    let activateButton = null;

    if (permissions.some(permission => permission.name === 'branch.create')) {
      const isActivated = data.is_activated === true || data.is_activated === "true";
      const iconColor = isActivated ? "text-dash3" : "text-dash5";
      const btnLabel = isActivated ? "Deactivate" : "Activate";

      activateButton = (
        <div className="mx-2 my-2 group relative">
          <button
            onClick={() => handleActivateConfirmation(data.id, isActivated)}
            disabled={confirmationLoading}
          >
            <ShieldFillPlus className={`w-5 h-5 ${iconColor}`} />
          </button>
          <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block ${iconColor} text-xs px-2 py-1 rounded`}>
            {btnLabel}
          </div>
        </div>
      );
    }

    let resetPasswordButton = null;

    if (permissions.some(permission => permission.name === 'branch.create')) {
      const isActive = data.status === 'active'; // Assuming you have status in data
      const iconColor = isActive ? "text-green-600" : "text-gray-400";
      const btnLabel = "Reset Password";

      resetPasswordButton = (
        <div className="mx-2 my-1 group relative mb-4">
          <button
            onClick={() => handleResetPasswordConfirmation(data.id)}
            disabled={confirmationLoading || !isActive}
            className={`p-1 rounded transition-all duration-200 hover:bg-gray-100 ${confirmationLoading || !isActive ? 'opacity-50 cursor-not-allowed' : ''
              }`}
          >
            {confirmationLoading ? (
              <div className="w-5 h-5 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
            ) : (
              <LockFill className={`w-5 h-5 ${iconColor}`} />
            )}
          </button>

          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 whitespace-nowrap">
            {!isActive ? "Cannot reset - Inactive" : btnLabel}
          </div>
        </div>
      );
    }

    return (
      <div className="flex justify-start p-4 relative">
        {permissions.some(permission => permission.name === 'branch.view') && (
          <>
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/details" state={{ branchData: data }}>
                <Eye className="w-5 h-5 text-darkGreen3" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen3 text-xs px-2 py-1 rounded">
                Details
              </div>
            </div>
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.view') && (
          <>
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/activity" state={{ id: data.id }}>
                <PersonLinesFill className="w-5 h-5 text-darkGreen2" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-darkGreen2 text-xs px-2 py-1 rounded">
                Activities
              </div>
            </div>
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.edit') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/edit" state={{ data }}>
              <PencilSquare className="w-5 h-5 text-dash4" />
            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
              Edit
            </div>
          </div>
        )}

        {permissions.some(permission => permission.name === 'branch.edit') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/assign-head-office" state={{ branchData: data }}>
              <Building className="w-5 h-5 text-purple-600" />
            </Link>
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-purple-600 text-xs px-2 py-1 rounded whitespace-nowrap">
              {data.head_office ? "Reassign HO" : "Assign HO"}
            </div>
          </div>
        )}

        {permissions.some(permission => permission.name === 'branch.create') && (
          <>
            {activateButton}
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.create') && (
          <>
            {resetPasswordButton}
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.view') && (
          <>
            <div className="mx-2 my-2 group relative">
              <Link to="/operations/branch/customer" state={{ data }}>
                <PeopleFill className="w-5 h-5 text-orange1" />
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-orange1 text-xs px-2 py-1 rounded">
                Customers
              </div>
            </div>
          </>
        )}

        {permissions.some(permission => permission.name === 'branch.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/sales" state={{ mydata: data }}>
              <CardList className="w-5 h-5 text-black1" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-black1 text-xs whitespace-nowrap">
                Sales
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'wallet.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/wallets/history" state={{ data }}>
              <CashStack className="w-5 h-5 text-darkGreen3" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-darkGreen3 text-xs whitespace-nowrap">
                Wallets History
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.fund_wallet') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/wallet/funding" state={{ id: data.id }}>
              <Wallet2 className="w-5 h-5 text-dash3" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash3 text-xs whitespace-nowrap">
                Fund Wallets
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.incentive.view') && data.status === "active" && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/incentives/details" state={{ id: data.id }}>
              <CashCoin className="w-5 h-5 text-orange1" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-orange1 text-xs whitespace-nowrap">
                Incentive Details
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/customer/reports" state={{ mydata: data }}>
              <PersonVcardFill className="w-5 h-5 text-dash4" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash4 text-xs whitespace-nowrap">
                Top Customer
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.view') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/products" state={{ data }}>
              <CardCheckList className="w-5 h-5 text-orange1" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-orange1 text-xs whitespace-nowrap">
                Branch Product
              </div>
            </Link>
          </div>
        )}
        {permissions.some(permission => permission.name === 'branch.remittance.deduct') && (
          <div className="mx-2 my-2 group relative">
            <Link to="/operations/branch/remittance/deducted" state={{ data }}>
              <Cash className="w-5 h-5 text-dash3" />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block text-dash3 text-xs whitespace-nowrap">
                Deduct Remittance
              </div>
            </Link>
          </div>
        )}
      </div>
    );
  };

  const columns = [
    {
      name: "Branch Name",
      selector: (row) => (row.name ? row.name.toUpperCase() : ""),
      sortable: true,
      width: "300px",
    },
    {
      name: "Branch Manager",
      selector: (row) =>
        Array.isArray(row.sales_representatives) && row.sales_representatives.length > 0
          ? row.sales_representatives.join(", ").toUpperCase()
          : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        const status = row.status?.toLowerCase();
        let statusClass = "";

        if (status === "active") {
          statusClass = "text-dash";
        } else if (status === "pending") {
          statusClass = "text-dash3";
        } else {
          statusClass = "text-dash5";
        }

        return (
          <span className={statusClass}>
            {row.status ? row.status.toUpperCase() : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "120px",
    },
    {
      name: "Phone",
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.phone_number
              ? row.phone_number
              : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
            {row.email
              ? row.email.toLowerCase()
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Activation Status",
      sortable: true,
      cell: (row) => {
        const isActive = row.is_activated === true || row.is_activated === "true";
        const statusText = isActive ? "ACTIVE" : "INACTIVE";
        const statusClass = isActive ? "text-dash" : "text-dash3";

        return (
          <span className={statusClass}>
            {statusText}
          </span>
        );
      },
      width: "200px",
    },
    {
      name: "State",
      selector: (row) => row.state ? row.state.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "City",
      selector: (row) => row.city ? row.city.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
    {
      name: "Head Office",
      sortable: true,
      width: "250px",
      cell: (row) => {
        if (row.head_office && row.head_office.name) {
          return (
            <div className="flex items-center gap-2">
              <Building className="w-4 h-4 text-darkGreen3" />
              <span className="font-medium text-gray-900">
                {row.head_office.name.toUpperCase()}
              </span>
            </div>
          );
        }
        return (
          <button
            onClick={() => navigate('/operations/branch/assign-head-office', { state: { branchData: row } })}
            className="px-3 py-1.5 bg-orange1 text-white text-xs font-medium rounded hover:bg-orange-600 transition-colors"
          >
            Add HO
          </button>
        );
      },
    },
    {
      name: "Created By",
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.creator.fullname
              ? row.creator.fullname.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md bg-dash5 text-lGrey2 text-xs">
            {row.creator.email
              ? row.creator.email
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Date Created",
      selector: (row) => (row.name ? formatDate(row.created_at) : "NOT AVAILABLE"),
      sortable: true,
      width: "200px",
    },
  ];

  // Filter data based on search text, status, AND date range
  const filteredItems = branchOpe.filter((item) => {
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );

    // Filter data based on selected branch status
    const matchesBranchStatus =
      !selectedBranchStatus ||
      item.status.toLowerCase() === selectedBranchStatus.toLowerCase();

    // Filter data based on activation status
    const matchesActivationStatus =
      !selectedActivationStatus ||
      (selectedActivationStatus === "active" && (item.is_activated === true || item.is_activated === "true")) ||
      (selectedActivationStatus === "inactive" && (item.is_activated === false || item.is_activated === "false"));

    // Filter data based on date range
    let matchesDateRange = true;
    if (areDatesSelected && item.created_at) {
      const itemDate = new Date(item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);

      // Set time to end of day for end date
      endDate.setHours(23, 59, 59, 999);

      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesBranchStatus && matchesActivationStatus && matchesDateRange;
  });

  const data = filteredItems.map((branchOpe) => ({
    name: branchOpe.name,
    phone_number: branchOpe.phone_number,
    is_activated: branchOpe.is_activated || "NOT AVAILABLE",
    state: branchOpe.state,
    city: branchOpe.city,
    status: branchOpe.status,
    creator: branchOpe.creator,
    email: branchOpe.email,
    created_at: branchOpe.created_at,
    id: branchOpe.id,
    address: branchOpe.address,
    sales_representatives: branchOpe.sales_representatives || [],
    nin: branchOpe.nin || "NOT AVAILABLE",
    // newly added
    wallet: branchOpe.wallet || null,
    bank_account: branchOpe.bank_account || null,
    wallet_balance: branchOpe.wallet_balance || "0.00",
    incentive_balance: branchOpe.incentive_balance || "0.00",
    float_balance: branchOpe.float_balance || "0.00",
    expense_balance: branchOpe.expense_balance || "0.00",
    notification_status: branchOpe.notification_status || false,
    two_factor_enabled: branchOpe.two_factor_enabled || false,
    head_office: branchOpe.head_office || null,
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="sm:rounded-lg py-6 w-full">

          <section className="w-full pl-[3%] pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            {/* Mobile Layout - Stacked */}
            <div className="md:hidden flex flex-col space-y-4">
              <nav className="bg-gray-200 py-2 px-4 rounded-lg w-full">
                <ol className="list-none p-0 inline-flex mb-0 items-center flex-wrap">
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 text-sm">
                      Operations
                    </p>
                    <ChevronRightIcon className="w-3 h-3" />
                  </li>
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 text-sm">
                      Branch
                    </p>
                    <ChevronRightIcon className="w-3 h-3" />
                  </li>
                  <li className="flex items-center">
                    <p className="text-orange1 text-sm">List</p>
                  </li>
                </ol>
              </nav>
              {permissions.some(permission => permission.name === 'property.create') && (
                <div className="w-full">
                  <Link
                    to="/operations/branch/create"
                    className="w-full text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
                  >
                    <PlusSquareFill className="mr-2" />
                    Add New Branch
                  </Link>
                </div>
              )}
            </div>

            {/* Desktop Layout - Side by side */}
            <div className="hidden md:flex justify-between items-center">
              <nav className="bg-gray-200 py-2 px-4 rounded-lg w-full">
                <ol className="list-none p-0 inline-flex mb-0 items-center flex-wrap">
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 text-sm">
                      Operations
                    </p>
                    <ChevronRightIcon className="w-3 h-3" />
                  </li>
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2 text-sm">
                      Branch
                    </p>
                    <ChevronRightIcon className="w-3 h-3" />
                  </li>
                  <li className="flex items-center">
                    <p className="text-orange1 text-sm">List</p>
                  </li>
                </ol>
              </nav>
              {/* {permissions.some(permission => permission.name === 'property.create') && (
                <div className="min-w-[200px] my-2">
                  <Link
                    to="/operations/branch/create"
                    className="w-full text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
                  >
                    <PlusSquareFill className="mr-2" />
                    Add New Branch
                  </Link>
                </div>
              )} */}
            </div>
          </section>

          {/* Filter Controls Section - Responsive */}
          <div className="pb-4 bg-white dark:bg-gray-900">
            {/* DESKTOP FILTERS (md and up) - All in one row */}
            <div className="hidden md:flex flex-wrap items-center gap-3">
              {/* Search Input Field with Icon */}
              <div className="relative flex-grow min-w-[200px]">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Branch Status Dropdown */}
              <div className="relative min-w-[180px]">
                <div>
                  <button
                    type="button"
                    className="bg-darkGreen3 inline-flex w-full justify-between items-center rounded-md px-3 py-2.5 text-sm font-semibold text-dGrey3"
                    id="menu-button"
                    aria-expanded={isDropdownOpen}
                    aria-haspopup="true"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <span className="truncate">
                      {selectedBranchStatus || "Branch Status"}
                    </span>
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                  </button>
                </div>
                {isDropdownOpen && (
                  <div
                    className="absolute right-0 z-10 mt-1 w-full origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                  >
                    <div
                      className="py-1 rounded-md"
                      role="none"
                      style={{ backgroundColor: "white" }}
                    >
                      <button
                        onClick={() => handleStatusSelect("active")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Active
                      </button>
                      <button
                        onClick={() => handleStatusSelect("blocked")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Blocked
                      </button>
                      <button
                        onClick={() => handleStatusSelect("suspend")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Suspend
                      </button>
                      <button
                        type="button"
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        onClick={() => handleStatusSelect("")}
                      >
                        All Status
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {permissions.some(permission => permission.name === 'property.create') && (
                <div className="min-w-[200px] my-2">
                  <Link
                    to="/operations/branch/create"
                    className="w-full text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-3 text-center inline-flex justify-center items-center"
                  >
                    <PlusSquareFill className="mr-2" />
                    Add New Branch
                  </Link>
                </div>
              )}


              {/* Start Date Input */}
              {/* <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.start_date}
                    onChange={(e) => handleFilterChange("start_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    max={filters.end_date || undefined}
                    placeholder="Start Date"
                  />
                </div>
              </div> */}

              {/* End Date Input */}
              {/* <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.end_date}
                    onChange={(e) => handleFilterChange("end_date", e.target.value)}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    min={filters.start_date || undefined}
                    placeholder="End Date"
                  />
                </div>
              </div> */}

              {/* Clear Dates Button - Only show when dates are selected */}
              {/* {areDatesSelected && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearDates}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Dates
                  </button>
                </div>
              )} */}

              {/* Download Button */}
              {/* <div className="min-w-[160px]">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                    ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areDatesSelected || loadingCSV}
                  title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Download CSV
                    </>
                  )}
                </button>
              </div> */}
            </div>

            {/* MOBILE FILTERS (below md) - Stacked layout */}
            <div className="md:hidden flex flex-col gap-3">
              {/* Search - Full width on mobile */}
              <div className="w-full">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-3 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
                    placeholder="Search branches..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Filters grid for mobile */}
              <div className="grid grid-cols-2 gap-3">
                {/* Status Dropdown - Full width on mobile */}
                {/* <div className="col-span-2">
                  <div>
                    <button
                      type="button"
                      className="bg-darkGreen3 inline-flex w-full justify-between items-center rounded-md px-4 py-3 text-sm font-semibold text-dGrey3"
                      id="mobile-menu-button"
                      aria-expanded={isDropdownOpen}
                      aria-haspopup="true"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      <span className="truncate">
                        {selectedBranchStatus || "Branch Status"}
                      </span>
                      <ChevronDown className="w-4 h-4 text-gray-400" />
                    </button>
                  </div>
                  {isDropdownOpen && (
                    <div
                      className="relative z-10 mt-1 w-full divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="mobile-menu-button"
                    >
                      <div
                        className="py-1 rounded-md"
                        role="none"
                        style={{ backgroundColor: "white" }}
                      >
                        <button
                          onClick={() => handleStatusSelect("active")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Active
                        </button>
                        <button
                          onClick={() => handleStatusSelect("pending")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Pending
                        </button>
                        <button
                          onClick={() => handleStatusSelect("inactive")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Inactive
                        </button>
                        <button
                          type="button"
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          onClick={() => handleStatusSelect("")}
                        >
                          All Status
                        </button>
                      </div>
                    </div>
                  )}
                </div> */}

                {/* Start Date - Half width on mobile */}
                {/* <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange("start_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      max={filters.end_date || undefined}
                      placeholder="Start"
                    />
                  </div>
                </div> */}

                {/* End Date - Half width on mobile */}
                {/* <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange("end_date", e.target.value)}
                      className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      min={filters.start_date || undefined}
                      placeholder="End"
                    />
                  </div>
                </div> */}

                {/* Clear Dates Button - Full width when shown */}
                {/* {areDatesSelected && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearDates}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear Dates
                    </button>
                  </div>
                )} */}

                {/* Download Button - Full width on mobile */}
                {/* <div className="col-span-2">
                  <button
                    onClick={handleDownloadCSV}
                    className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
                      ? "bg-orange1 text-lGrey3 hover:bg-orange-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={!areDatesSelected || loadingCSV}
                  >
                    {loadingCSV ? (
                      <>
                        <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
                        <span className="ml-2">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span className="ml-2">Download CSV</span>
                      </>
                    )}
                  </button>
                </div> */}
              </div>
            </div>

            {/* DESKTOP help text (md and up) */}
            {/* <div className="hidden md:flex items-center justify-between mt-2">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600">
                  Showing {sortedData.length} records from {filters.start_date} to {filters.end_date}
                </p>
              )}
            </div> */}

            {/* MOBILE help text (below md) */}
            {/* <div className="md:hidden mt-3">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500 text-center mb-2">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600 text-center">
                  Showing {sortedData.length} records
                </p>
              )}
            </div> */}
          </div>

          {/* Data Table */}
          {loading ? (
            <Spinner loading={loading} />
          ) : (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={
                <div className="text-center py-8">
                  {areDatesSelected ?
                    "No branches found for the selected date range" :
                    "No branches found"
                  }
                </div>
              }
              expandableRows
              expandableRowsComponent={ExpandableComponent}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default BranchList;



